import axios from 'axios';

import {
    billingRequest,
    billingFail,
    patientBillsSuccess,
    allBillsSuccess,
    singleBillSuccess,
    newBillSuccess,
    updateBillSuccess,
    paymentAddedSuccess,
    deleteBillSuccess
} from '../slices/billingSlice';

export const getPatientBills = patientId => async (dispatch) => {
    try {
        dispatch(billingRequest());
        const { data } = await axios.get(`/api/v1/patient/${patientId}/billing`);
        dispatch(patientBillsSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response.data.message));
    }
}

export const getAllBills = (status) => async (dispatch) => {
    try {
        dispatch(billingRequest());
        let link = `/api/v1/admin/billing`;
        if (status) {
            link += `?status=${status}`;
        }
        const { data } = await axios.get(link);
        dispatch(allBillsSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response.data.message));
    }
}

export const getBill = (id, token) => async (dispatch) => {
    try {
        dispatch(billingRequest());
        const url = token ? `/api/v1/invoice/${id}?token=${encodeURIComponent(token)}` : `/api/v1/billing/${id}`;
        const { data } = await axios.get(url);
        dispatch(singleBillSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response?.data?.message || 'Failed to load invoice'));
    }
}

export const createBill = billData => async (dispatch) => {
    try {
        dispatch(billingRequest());
        const { data } = await axios.post(`/api/v1/admin/billing/new`, billData);
        dispatch(newBillSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response.data.message));
    }
}

export const updateBill = (id, billData) => async (dispatch) => {
    try {
        dispatch(billingRequest());
        const { data } = await axios.put(`/api/v1/admin/billing/${id}`, billData);
        dispatch(updateBillSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response.data.message));
    }
}

export const addPayment = (id, paymentData) => async (dispatch) => {
    try {
        dispatch(billingRequest());
        const { data } = await axios.put(`/api/v1/admin/billing/${id}/payment`, paymentData);
        dispatch(paymentAddedSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response.data.message));
    }
}

export const deletePayment = (id, paymentId) => async (dispatch) => {
    try {
        dispatch(billingRequest());
        const { data } = await axios.delete(`/api/v1/admin/billing/${id}/payment/${paymentId}`);
        dispatch(paymentAddedSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response.data.message));
    }
}

export const cancelBill = id => async (dispatch) => {
    try {
        dispatch(billingRequest());
        const { data } = await axios.delete(`/api/v1/admin/billing/${id}`);
        dispatch(deleteBillSuccess(data));
    } catch (error) {
        dispatch(billingFail(error.response.data.message));
    }
}
